import { render, staticRenderFns } from "./ProjectCurrencyForm.vue?vue&type=template&id=555075f4&scoped=true&"
import script from "./ProjectCurrencyForm.vue?vue&type=script&lang=js&"
export * from "./ProjectCurrencyForm.vue?vue&type=script&lang=js&"
import style0 from "./ProjectCurrencyForm.vue?vue&type=style&index=0&id=555075f4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "555075f4",
  null
  
)

export default component.exports